import { render, staticRenderFns } from "./BillInvoicePrintDetail.vue?vue&type=template&id=2dfe5800&"
import script from "./BillInvoicePrintDetail.vue?vue&type=script&lang=js&"
export * from "./BillInvoicePrintDetail.vue?vue&type=script&lang=js&"
import style0 from "./BillInvoicePrintDetail.vue?vue&type=style&index=0&id=2dfe5800&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports